import React from 'react'
import { Field } from '../../form'
import { Translation } from 'react-i18next'
import MenuItem from '@material-ui/core/MenuItem'
import { useDispatch } from 'react-redux'
import { changeVATPercent } from '../../actions'
import { employerSide } from '../../routerHistory'

const CountrySelectField = React.memo(
  ({ classes, countryList, control, form, setValue, watch, disabled }) => {
    const dispatch = useDispatch()
    return (
      <Translation>
        {(t) => (
          <Field
            name="country"
            inputType="select"
            className={classes.select}
            label={t('asiakkaat.label')}
            control={control}
            disabled={disabled}
            onChange={(e) => {
              if (form === 'invoice' && e.target.value !== 1) {
                setValue('quick_pay', false)
              }
              if (
                form === 'invoice' &&
                e.target.value === 1 &&
                watch.vat_selection === 'vat_abroad'
              ) {
                setValue('vat_selection', 25.5)
                dispatch(changeVATPercent(25.5, watch.rows))
              }
            }}
          >
            {createCountryItems(t, countryList)}
          </Field>
        )}
      </Translation>
    )
  }
)

const createCountryItems = (t, countries) => {
  const countriesTranslated = countries.map((country) => {
    return {
      country: employerSide
        ? t(`employer.countryList.${country.country_id}`)
        : t(`countryList.${country.country_id}`),
      id: country.country_id
    }
  })
  const translationSorted = countriesTranslated.sort((a, b) => {
    const countryA = a.country.toLowerCase()
    const countryB = b.country.toLowerCase()
    if (
      countryA === 'finland' ||
      countryA === 'suomi' ||
      countryA === 'soome'
    ) {
      return -1 // Finland comes first
    } else if (
      countryB === 'finland' ||
      countryB === 'suomi' ||
      countryB === 'soome'
    ) {
      return 1 // Finland comes first
    }
    if (countryA === 'other' || countryA === 'muu') {
      return 1 // Other comes last
    } else if (countryB === 'other' || countryB === 'muu') {
      return -1 // Other comes last
    }

    return countryA.localeCompare(countryB)
  })
  return translationSorted.map((countryTranslated) => (
    <MenuItem key={countryTranslated.id} value={countryTranslated.id}>
      {countryTranslated.country}
    </MenuItem>
  ))
}

export default CountrySelectField
